// extracted by mini-css-extract-plugin
export default {"card":"ProFeaturesCard_card__ZB3AX","grid":"ProFeaturesCard_grid__pgI0x","item":"ProFeaturesCard_item__E9Obk","icon":"ProFeaturesCard_icon__SQZ6p"};